const units = [
  "บก.ทอ.",
  "สพร.ทอ.",
  "สง.ปรอมน.ทอ.",
  "สลก.ทอ.",
  "สบ.ทอ.",
  "กพ.ทอ.",
  "ขว.ทอ.",
  "ยก.ทอ.",
  "กบ.ทอ.",
  "กร.ทอ.",
  "ทสส.ทอ.",
  "สปช.ทอ.",
  "กง.ทอ.",
  "จร.ทอ.",
  "สตน.ทอ.",
  "สนภ.ทอ.",
  "สบน.ทอ.",
  "สธน.ทอ.",
  "ศซบ.ทอ.",
  "คปอ.",
  "อย.",
  "ศปอว.",
  "รร.การบิน",
  "บน.1",
  "บน.2",
  "บน.3",
  "บน.4",
  "บน.5",
  "บน.6",
  "บน.7",
  "บน.21",
  "บน.23",
  "บน.41",
  "บน.46",
  "บน.56",
  "ชอ.",
  "สอ.ทอ.",
  "สพ.ทอ.",
  "พอ.",
  "พธ.ทอ.",
  "ชย.ทอ.",
  "ขส.ทอ.",
  "ศซว.ทอ.",
  "ยศ.ทอ.",
  "รร.นนก.",
  "ศวอ.ทอ.",
  "สก.ทอ.",
  "สน.ผบ.ดม.",
  "สวบ.ทอ.",
];

export default units;